import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js";

// Connects to data-controller="renewals"
export default class extends Controller {
  static targets = [
    "permanent", "scale",
    "comision", "operatorBilledComision",
    "isactivedadvancedbilling", "advance",
    "buttonBone", "inputBone",
    "buttonRenueve", "inputRenueve",
    "buttonScaling", "inputScaling",
    "buttonScalingBasis", "inputScalingBasis",
    "bonosporcontrato", "bonocampingprice", "tasadgoj", "initialAmount", "finalAmount", "rsPercentage", "mingaran", "hostingfijo", "comision", "advanceAmount", "consumedAdvance"
  ]
  connect() {
    if (this.hasInputRenueveTarget) {
      this.toggleDateFieldRenueveShare();
      this.updateRenueveButtons(this.inputRenueveTarget.value);
    }

    if (this.hasInputBoneTarget) {
      this.updateBoneButtons(this.inputBoneTarget.value);
    }

    if (this.hasInputScalingTarget) {
      this.updateScalingButtons(this.inputScalingTarget.value);
    }

    if (this.hasInputScalingBasisTarget) {
      this.updateScalingBasisButtons(this.inputScalingBasisTarget.value);
    }

    if (this.hasIsactivedadvancedbillingTarget) {
      this.checkAdvancedBilling();
    }

    const cleaveTargets = [
      "bonosporcontrato", "bonocampingprice", "tasadgoj", "initialAmount", "finalAmount", "rsPercentage", "mingaran", "hostingfijo", "comision", "advanceAmount", "consumedAdvance"
    ];

    cleaveTargets.forEach(target => {
      const hasTargetFunction = `has${target.charAt(0).toUpperCase() + target.slice(1)}Target`;
      if (this[hasTargetFunction]) {
        const inputElement = this[target + "Target"];
        // Store the current value and convert decimal point to comma if needed
        const currentValue = inputElement.value;
        const formattedValue = currentValue ? currentValue.replace('.', ',') : '';
        
        new Cleave(inputElement, {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.'
        });
        
        // Set the formatted value after Cleave initialization
        if (formattedValue) {
          inputElement.value = formattedValue;
        }
      }
    });
  }

  toggleDateFieldRenueveShare() {
    if (this.inputRenueveTarget.value === "with_scaling") {
      this.scaleTarget.classList.remove("hidden");
      this.permanentTarget.classList.add("hidden");
      this.permanentTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });

      this.updateScalingButtons('');
      this.updateScalingBasisButtons('');

    } else if (this.inputRenueveTarget.value === "permanent") {
      this.scaleTarget.classList.add("hidden");
      this.permanentTarget.classList.remove("hidden");

      this.scaleTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
      this.scaleTarget.querySelectorAll("select").forEach((select) => {
        select.selectedIndex = 0;
      });

      this.updateScalingButtons('');
      this.updateScalingBasisButtons('');

    } else {
      this.scaleTarget.classList.add("hidden");
      this.permanentTarget.classList.add("hidden");
      this.scaleTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
      this.scaleTarget.querySelectorAll("select").forEach((select) => {
        select.selectedIndex = 0;
      });
      this.permanentTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
    }
  }

  checkComision() {
    if (parseFloat(this.comisionTarget.value) > 0) {
      this.operatorBilledComisionTarget.disabled = false;
      this.operatorBilledComisionTarget.classList.remove("bg-gray-300")
    } else {
      this.operatorBilledComisionTarget.disabled = true;
      this.operatorBilledComisionTarget.classList.add("bg-gray-300")
      this.operatorBilledComisionTarget.checked = false;
    }
  }

  checkAdvancedBilling() {
    if (this.isactivedadvancedbillingTarget.checked) {
      this.advanceTarget.classList.remove("hidden")
    } else {
      this.advanceTarget.classList.add("hidden")
      this.advanceTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
      this.advanceTarget.querySelector("input[type='checkbox']").checked = false;
    }
  }

  updateBoneButtons(selectedBone) {
    this.buttonBoneTargets.forEach((button) => {
      if (button.dataset.state === selectedBone) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeBone(event) {
    event.preventDefault();
    let selectedBone = event.currentTarget.dataset.state;
    this.updateBoneButtons(selectedBone);
    this.inputBoneTarget.value = selectedBone;
  }

  updateRenueveButtons(selectedRenueve) {
    this.buttonRenueveTargets.forEach((button) => {
      if (button.dataset.state === selectedRenueve) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeRenueve(event) {
    event.preventDefault();
    let selectedRenueve = event.currentTarget.dataset.state;
    this.updateRenueveButtons(selectedRenueve);
    this.inputRenueveTarget.value = selectedRenueve;
    this.toggleDateFieldRenueveShare();
  }

  updateScalingButtons(selectedScaling) {
    this.buttonScalingTargets.forEach((button) => {
      if (button.dataset.state === selectedScaling) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeScaling(event) {
    event.preventDefault();
    let selectedScaling = event.currentTarget.dataset.state;
    this.updateScalingButtons(selectedScaling);
    this.inputScalingTarget.value = selectedScaling;
  }

  updateScalingBasisButtons(selectedScalingBasis) {
    this.buttonScalingBasisTargets.forEach((button) => {
      if (button.dataset.state === selectedScalingBasis) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeScalingBasis(event) {
    event.preventDefault();
    let selectedScalingBasis = event.currentTarget.dataset.state;
    this.updateScalingBasisButtons(selectedScalingBasis);
    this.inputScalingBasisTarget.value = selectedScalingBasis;
  }
}
